import styled from 'styled-components';

export const CardContainer = styled.div`
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.1),
    0px 2px 2px 0px rgba(0, 0, 0, 0.09), 0px 4px 2px 0px rgba(0, 0, 0, 0.05);
  border-radius: ${({ theme }) => theme.radius.l};
  padding: ${({ theme }) => theme.spacing.m};
`;
